module.exports = __webpack_public_path__ + "img/usmf-logo.4d026032.png";